<script>
import store from '@/store';
import popupMail from '@/views/popupSearch/popup_mail/store';
import template from './template.html';
import helpers from '@/utils/helpers';
import './style.scss';
import { mapMutations, mapState, mapActions } from 'vuex';
import AnsCheckbox from '@/components/ansCheckbox/index.vue';
import messages, { MSG_TITLE, MSG_TYPE, MSG_BUTTON } from '@/utils/messages';
import PopupArea from '@/views/popupSearch/popup_area/store';
import PopupUser from '@/views/popupSearch/popup_user/store';
import PopupCustomer from '@/views/popupSearch/popup_customer/store';
import PopupUserCustomer from '@/views/popupSearch/popup_user_customer/store';

var Mail = {
    template: template,
    components: {
        AnsCheckbox,
        PopupCustomer,
        PopupArea,
        PopupUser
    },
    beforeCreate() {
        if (!store.hasModule('popupMail')) {
            store.registerModule('popupMail', popupMail);
        }
        if (!store.hasModule('PopupArea')) {
            store.registerModule('PopupArea', PopupArea);
        }
        if (!store.hasModule('PopupUser')) {
            store.registerModule('PopupUser', PopupUser);
        }
        if (!store.hasModule('PopupCustomer')) {
            store.registerModule('PopupCustomer', PopupCustomer);
        }
        if (!store.hasModule('PopupUserCustomer')) {
            store.registerModule('PopupUserCustomer', PopupUserCustomer);
        }
    },
    props: {
        initData: [String, Number]
    },
    data() {
        return {
            message_confirm: ''
        };
    },
    watch: {
        initData: {
            handler: 'updateInitData',
            deep: true
        }
    },
    mounted() {
        this.resetData();
    },
    unmounted() {},
    computed: {
        ...mapState('app', ['user']),
        ...mapState('popupMail', ['data']),
        disableButton1() {
            return !this.data.message_1;
        },
        disableButton2() {
            return !this.data.message_2;
        },
        disableUserCusSearch() {
            return !this.data.customer_cd;
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('popupMail', ['resetData']),
        ...mapActions('PopupArea', ['searchAreaInfo']),
        ...mapActions('PopupUser', ['searchEmployeeInfo']),
        ...mapActions('popupMail', ['storeSave', 'getMessageConfirm']),
        ...mapActions('PopupCustomer', ['searchCustomerInfo']),
        ...mapActions('PopupUserCustomer', ['searchUserCustomerInfo']),
        getCustomerName(data) {
            this.data.customer_name = data;
            this.data.responsible_person_2 = '';
            this.data.responsible_person_name_2 = '';
        },
        getUserName(data) {
            this.data.user_name = data;
        },
        getUserName2(data) {
            this.data.responsible_person_name_2 = data;
        },
        getAreaName(data) {
            this.data.supervising_department_name_1 = data;
            this.data.user_id = '';
            this.data.user_name = '';
        },
        getAreaName2(data) {
            this.data.supervising_department_name_2 = data;
            this.data.customer_cd = '';
            this.data.customer_name = '';
            this.data.responsible_person_2 = '';
            this.data.responsible_person_name_2 = '';
        },
        changeUserCode(index, value) {
            if (value) {
                this.searchEmployeeInfo({
                    department_cd: this.data.supervising_department_cd_1,
                    user_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.user_id = result.user_cd;
                            this.data.user_name = result.user_name;
                        } else {
                            this.data.user_id = '';
                            this.data.user_name = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.user_id = '';
                this.data.user_name = '';
            }
        },
        changeUserCode2(index, value) {
            if (value) {
                this.searchUserCustomerInfo({
                    user_cd: value,
                    customer_cd: this.data.customer_cd,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.responsible_person_2 = result.user_cd;
                            this.data.responsible_person_name_2 = result.user_name;
                        } else {
                            this.data.responsible_person_2 = '';
                            this.data.responsible_person_name_2 = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.responsible_person_2 = '';
                this.data.responsible_person_name_2 = '';
            }
        },
        referAreaSearch(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.supervising_department_cd_1 = result.department_cd;
                            this.data.supervising_department_name_1 = result.department_name;
                        } else {
                            this.data.supervising_department_cd_1 = '';
                            this.data.supervising_department_name_1 = '';
                        }
                        this.data.user_id = '';
                        this.data.user_name = '';
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.supervising_department_cd_1 = '';
                this.data.supervising_department_name_1 = '';
                this.data.user_id = '';
                this.data.user_name = '';
            }
        },
        referAreaSearch2(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.supervising_department_cd_2 = result.department_cd;
                            this.data.supervising_department_name_2 = result.department_name;
                        } else {
                            this.data.supervising_department_cd_2 = '';
                            this.data.supervising_department_name_2 = '';
                        }
                        this.data.customer_cd = '';
                        this.data.customer_name = '';
                        this.data.responsible_person_2 = '';
                        this.data.responsible_person_name_2 = '';
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.supervising_department_cd_2 = '';
                this.data.supervising_department_name_2 = '';
                this.data.customer_cd = '';
                this.data.customer_name = '';
                this.data.responsible_person_2 = '';
                this.data.responsible_person_name_2 = '';
            }
        },
        changeCustomerCode(index, value) {
            if (value) {
                this.searchCustomerInfo({
                    department_cd: this.data.supervising_department_cd_2,
                    customer_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.customer_cd = result.customer_cd;
                            this.data.customer_name = result.customer_name;
                        } else {
                            this.data.customer_cd = '';
                            this.data.customer_name = '';
                        }
                        this.data.responsible_person_2 = '';
                        this.data.responsible_person_name_2 = '';
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.customer_cd = '';
                this.data.customer_name = '';
                this.data.responsible_person_2 = '';
                this.data.responsible_person_name_2 = '';
            }
        },
        submitForm(kubun) {
            let message_confirm = '';
            if (kubun == 0) {
                message_confirm = this.data.message_1 + '<br>' + this.message_confirm + '<br> 送信してもよろしいですか？';
            } else {
                message_confirm = this.data.message_2 + '<br>' + this.message_confirm + '<br> 送信してもよろしいですか？';
            }
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C010,
                content: message_confirm,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (ok) {
                        this.errors = [];
                        this.data.kubun = kubun;
                        this.storeSave({
                            body: {
                                ...this.data
                            },
                            callback: (response) => {
                                this.showModalMessage({
                                    title: MSG_TITLE.S001,
                                    content: messages.S004,
                                    okText: MSG_BUTTON.okText,
                                    callback: (ok) => {
                                        console.log(response);
                                        if (ok) {
                                            //
                                        }
                                    }
                                });
                            },
                            onErrorValidate: (errors) => {
                                this.errors = helpers.renderError(errors, this.S9007);
                            },
                            onError: (errorMessage) => {
                                this.showHeaderError([errorMessage.remark ?? messages.E999]);
                            }
                        });
                    }
                }
            });
        },
        checkMessageConfirm(kubun) {
            this.data.kubun = kubun;
            this.getMessageConfirm({
                body: {
                    ...this.data
                },
                callback: (response) => {
                    //
                    if (response.Data != undefined) {
                        this.message_confirm = response.Data;
                    }
                    this.submitForm(kubun);
                },
                onErrorValidate: (errors) => {
                    this.errors = helpers.renderError(errors, this.S9007);
                },
                onError: (errorMessage) => {
                    this.showHeaderError([errorMessage.remark ?? messages.E999]);
                }
            });
        }
    }
};
export default Mail;
</script>
